import { render, staticRenderFns } from "./mail_logs.vue?vue&type=template&id=a39d7552&scoped=true"
import script from "./mail_logs.vue?vue&type=script&lang=js"
export * from "./mail_logs.vue?vue&type=script&lang=js"
import style0 from "./mail_logs.vue?vue&type=style&index=0&id=a39d7552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39d7552",
  null
  
)

export default component.exports